import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

// import FormField from 'containers/FormField';
// import LikertField from 'components/LikertField';

import FormProvider from 'routes/Documents/containers/FormProvider';
import FormField from 'containers/FormField';

import SDMTContainer from '../containers/SDMTContainer';

import { fssWrapper } from './Scores.less';
import { getLatestCommitData } from 'lib/documentHandling';
import { FormattedMessage } from 'react-intl';

const SDMTForm = props => (
  <FormProvider {...props}>
    <div className={fssWrapper}>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <FormField
              name="sdmtResult"
              component={SDMTContainer}
              token={props.token}
              editingDocumentId={props.editingDocumentId}
              editingDocument={props.editingDocument}
            />
            {/* <SDMTContainer /> */}
          </Col>
        </Row>
        {getLatestCommitData(props.editingDocument) && getLatestCommitData(props.editingDocument).sdmtResult && (
          <React.Fragment>
            <Row style={{ marginTop: '3rem' }}>
              <Col xs={5}>
                <FormattedMessage id="sdmt.labels.filled" />
              </Col>
              <Col xs={7}>
                <p style={{ fontWeight: 600 }}>
                  {getLatestCommitData(props.editingDocument).sdmtResult.testAnswers.length}
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={5}>
                <FormattedMessage id="sdmt.labels.score" />
              </Col>
              <Col xs={7}>
                <p style={{ fontWeight: 600 }}>
                  {getLatestCommitData(props.editingDocument).sdmtResult.rightAnswerCount}
                </p>
              </Col>
            </Row>
          </React.Fragment>
        )}

        <Row left="xs" style={{ marginTop: '3rem' }}>
          <Col xs={12}>
            Material from the SDMT copyright © 1973 by Western Psychological Services. Format adapted by M.
            Aittokallio, StellarQ Oy, for use under license of the publisher, WPS, (rights@wpspublish.com). No
            additional reproduction, in whole or in part, by any medium or for any purpose, may be made without the
            prior, written authorization of WPS.
            <br />
            All rights reserved.
          </Col>
        </Row>
      </Grid>
    </div>
  </FormProvider>
);

export default SDMTForm;
